
(function documentDigitalizeIndexingControllerDefinition() {
    'use strict';

    angular.module('Document')
        .controller('DocumentDigitalizeIndexingController', [
                '$scope', 'config', '$state', 'errorsExtend', '$stateParams', 'documentService', 'documentTypeService', 'auth', 'twainCapture', '$q', 'alerts', '$translate',
                'documentContainerService', 'authExtend', 'storageService', 'fileService', 'containerTypeService', 'doublyLinkedList',
                'organizationalUnitService', '$timeout',
                function documentController($scope, config, $state, errors, $stateParams, documentService, documentTypeService, auth, twainCapture, $q, alerts, $translate,
                                            documentContainerService, authExtend, storageService, fileService, containerTypeService, doublyLinkedList,
                                            organizationalUnitService, $timeout) {

                    /*
                     * Promesa que se utiliza para cancelar la digitalización
                     */
                    var cancelDeferred = null;
                    // Tamaño máximo de la lista de documentos. (los documentos viejos solo contienen un id en su data)
                    var maxDocumentsListSize = -1;
                    

                    function createDocumentObject(dummy) {
                        $scope.document = {
                            name: '',
                            documentTypes: [],
                            containers: [],
                            organizationalUnitId: authExtend.getOrganizationId(),
                            convertFilesToBlackAndWhite: twainCapture.isGrayScale(),
                            isDocumentPerFile: false,
                            hasMoreImages: true,
                            metadataAsName: 0
                        };

                        if (dummy) {
                            $scope.document.dummy = true;
                        }

                        // obtengo los archivos que son del mismo documento                        
                        $scope.aux = {
                            selectedDocumentTypes: [],
                            files: [],
                            metadataReplicate: []
                        };
                    }

                    createDocumentObject(true);

                    $scope.indexer = {
                        closed: true,
                        loading: false,
                        content: null,
                        index: null,
                        item: null,
                        invalid: false,
                        hasMoreImages: false
                    };

                    // lista doblemente vinculada de documentos (para poder ir hacia atras y adelante).
                    // El tail deberá ser el documento que se está digitalizando (que no necesariamente es $scope.document).
                    var documentsList = null;
                    // Nodo del documento que se está editando.
                    $scope.currentDocumentNode = null;

                    $scope.auxdocumentType = {};
                    $scope.optionsDocumentTypes = [];
                    // contenedores para los que el usuario tiene permisos
                    $scope.allowedContainers = [];

                    $scope.initDocumentFind = function () {
                        if (storageService.getStateBackFind()) {
                            $state.go(storageService.getStateBackFind());
                        }
                    };

                    /*
                     * Actualiza el nombre del documento actual en base al metadato modificado si el mismo tiene la marca "AsName"
                     */
                    $scope.changeAsName = function (value) {
                        if (value.updatesName) {
                            $scope.document.name = value.metadataValue;
                        }
                    };

                    documentTypeService.getFunctionsTypes(['DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE']).then(function (result) {
                        $scope.optionsDocumentTypes = result;
                    }, function (error) {
                        errors.showError(error);
                        $state.go('document-find');
                    });

                    documentContainerService.getIds()
                        .then(function (result) {
                            $scope.allowedContainers = result;
                        }, function (error) {
                            errors.showError(error);
                            $state.go('document-find');
                        });

                    function hasContainerPermissions(container) {
                        return $scope.allowedContainers.findIndex(function (allowed) {
                            return allowed.id === container.id;
                        });
                    }

                    $scope.loadDocTypeMetadata = function (documentType, oldValues) {

                        var documentDocType = {
                            documentTypeName: documentType.name,
                            documentTypeId: documentType.id,
                            metadatas: []
                        };

                        if (oldValues) {
                            documentDocType.id = oldValues.id;
                        }

                        documentType.metadata.forEach(function (metadata) {
                            var value = '';

                            if (oldValues) {
                                for (var i in oldValues.metadatas) {
                                    if (oldValues.metadatas.hasOwnProperty(i)) {
                                        if (oldValues.metadatas[i].metadataId === metadata.metadataId) {
                                            value = oldValues.metadatas[i].metadataValue;
                                            break;
                                        }
                                    }
                                };
                            }

                            var newMetadata = {
                                idObject: documentDocType.documentTypeId + '' + metadata.metadataId,
                                metadataId: metadata.metadataId,
                                metadataIsRequired: metadata.isRequired,
                                metadataIsUnique: metadata.isUnique,
                                metadataValue: value,
                                metadataType: metadata.metadataType,
                                metadataLabel: metadata.metadataLabel,
                                metadataOptions: metadata.optionValues,
                                maskOptions: metadata.maskOptions,
                                mask: metadata.metadataMask,
                                maskPlaceHolder: metadata.metadataMaskPlaceHolder,
                                metadataAsName: metadata.asName,
                                metadataAttributes: metadata.attributes
                            };

                            documentDocType.metadatas.push(newMetadata);

                            if (metadata.asName) {
                                if (!$scope.document.metadataAsName) {
                                    // por si cambió el valor mientras se podía.
                                    $scope.document.name = value;
                                    newMetadata.updatesName = true;
                                }
                                $scope.document.metadataAsName++;
                            }
                        });

                        $scope.document.documentTypes.push(documentDocType);

                        if (oldValues) {
                            $scope.replicateValues(false);
                        } else {
                            $scope.replicateValues(true);
                        }
                    };

                    /*
                     * Carga un documento en el indexador.
                     * @param document {} El documento.
                     */
                    function loadDocument(document) {

                        if (typeof (document) === 'number') {
                            return loadDocumentById(document);
                        }

                        createDocumentObject();
                        
                        if (document.id) {
                            $scope.document.files = document.files;
                            $scope.aux.files = [];
                        } else {
                            $scope.aux.files = document.files;
                        }
                        $scope.document.versionId = document.versionId;
                        $scope.document.code = document.code;
                        $scope.document.name = document.name;
                        $scope.document.id = document.id;
                        $scope.document.containers = document.containers;
                        $scope.document.documentTypes = [];
                        $scope.document.hasMoreImages = document.hasMoreImages || false;
                        $scope.document.metadataAsName = 0;

                        $scope.document.containers.forEach(function (container) {

                            container.notEditable = !hasContainerPermissions(container);

                            $scope.selectContainer(container, true);
                        });

                        $scope.aux.selectedDocumentTypes = $scope.optionsDocumentTypes.filter(function (value) {

                            for (var i in document.documentTypes) {
                                if (document.documentTypes.hasOwnProperty(i)) {
                                    if (document.documentTypes[i].documentTypeId === value.id) {
                                        value.status = 'preSeleted';
                                        return true;
                                    }
                                }
                            }
                            return false;
                        });

                        document.documentTypes.forEach(function (type) {
                            $scope.selectDocumentType({ id: type.documentTypeId }, type);
                        });

                        $scope.previewFile($scope.aux.files[0] || null, 0);

                        $scope.loadingDocument = false;

                        return $q.when(document);
                    }

                    /**
                     * Carga un documento existente.
                     * @param id number Id del documento a mostrar.
                     */
                    function loadDocumentById(id) {

                        return documentService.getById(id, true)
                            .then(function (result) {

                                $scope.documentLoadError = false;

                                return loadDocument(result);

                            }, function (error) {
                                errors.showError(error);
                                $scope.documentLoadError = true;
                            });
                    };

                    /*
                     * Agrega un document type al documento actual.
                     */
                    $scope.selectDocumentType = function (documentType, oldValues) {
                        documentTypeService.getById(documentType.id, 'detail').then(function (result) {
                            $scope.loadDocTypeMetadata(result, oldValues);
                        }, function (error) {
                            errors.showError(error);
                            $state.go('document-find');
                        });
                    };

                    /*
                     * Remueve un document type del documento actual.
                     */
                    $scope.removeDocumentType = function (documentType) {

                        var document = $scope.document;

                        var indexOf = document.documentTypes.findIndex(function (docType) {
                            return docType.documentTypeId === documentType.id;
                        });

                        if (indexOf >= 0) {
                            var documentDocumentType = document.documentTypes[indexOf];

                            document.documentTypes.splice(indexOf, 1);

                            // Si tenía metadato de nombre entonces decremento.
                            if (documentDocumentType.metadatas.findIndex(function (metadata) {
                                return metadata.metadataAsName;
                            }) !== -1) {
                                document.metadataAsName--;
                                // Si existe otro type que tiene seteado el nombre entonces lo seteo
                                if (document.metadataAsName) {
                                    for (var i = 0; i < document.documentTypes.length; i++) {
                                        var docDocType = document.documentTypes[i];

                                        var m = docDocType.metadatas.find(function (metadata) {
                                            return metadata.metadataAsName;
                                        });
                                        if (m) {
                                            document.name = m.metadataValue;
                                            m.metadataAsName = true;
                                            return;
                                        }
                                    }
                                }
                            }
                        }
                    };

                    /*
                     * Retornará el indice del archivo (comparando por nombre) en el array $scope.aux.files
                     */
                    $scope.getIndexFile = function (fileNew) {

                        for (var i in $scope.aux.files) {
                            if ($scope.aux.files.hasOwnProperty(i)) {
                                var fileOld = $scope.aux.files[i];

                                if (fileOld.name === fileNew.name) {
                                    return i;
                                }
                            }
                        };

                        return -1;
                    };

                    /*
                     * Redirecciona a la pantalla de creación multiple de documentos.
                     */
                    $scope.cancel = function () {
                        $state.go('document-add-multiple');
                    };

                    /*
                     * Muestra un archivo del documento actual en el preview.
                     * item: Es el item del archivo en el documento.
                     * index: Es el indice del archivo en aux.
                     */
                    $scope.previewFile = function (item, index) {

                        $scope.indexer.content = null;
                        $scope.indexer.invalid = false;

                        if (item == null) {
                            return;
                        }

                        $scope.indexer.loading = true;

                        fileService.preview($scope.aux.files[index], true).then(function (result) {

                            $scope.indexer.content = result;

                            $scope.indexer.item = item;
                            $scope.indexer.index = index;
                            $scope.indexer.loading = false;
                        }, function (error) {
                            if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                                $scope.indexer.loading = false;
                                $scope.indexer.invalid = true;
                                $scope.indexer.item = item;
                                $scope.indexer.index = index;
                            }
                            else {
                                errors.showError(error);
                                $scope.closeIndexer();
                            }
                        });

                    };

                    /*
                     * Muestra el siguiente archivo del documento.
                     */
                    $scope.nextPreview = function () {
                        if ($scope.indexer.index + 1 < $scope.aux.files.length
                            && $scope.aux.files[$scope.indexer.index + 1]) {
                            $scope.indexer.index++;
                            $scope.previewFile($scope.aux.files[$scope.indexer.index], $scope.indexer.index);
                        }
                    };

                    /*
                     * Muestra el archivo anterior del documento.
                     */
                    $scope.prevPreview = function () {
                        if ($scope.indexer.index) {
                            $scope.indexer.index--;
                            $scope.previewFile($scope.aux.files[$scope.indexer.index], $scope.indexer.index);
                        }
                    };

                    /*
                     * Retornará la cantidad de metadatos de los document types del documento.
                     */
                    $scope.metadataCount = function () {
                        if ($scope.document.documentTypes && $scope.document.documentTypes.length) {
                            return $scope.document.documentTypes.reduce(function (valorPrevio, valorActual, indice, array) {
                                return valorPrevio + valorActual.metadatas.length;
                            }, 0);
                        }
                        return 0;
                    };

                    $scope.getReplicatedMetadata = function (metadata) {
                        for (var i = 0; $scope.aux.metadataReplicate.length > i; i++) {
                            if (metadata.metadataId === $scope.aux.metadataReplicate[i].metadataId) {
                                return $scope.aux.metadataReplicate[i];
                            }
                        }
                        return null;
                    };

                    $scope.replicateValues = function () {
                        for (var k = 0; $scope.document.documentTypes.length > k; k++) {
                            for (var l = 0; $scope.document.documentTypes[k].metadatas.length > l; l++) {
                                var m = $scope.document.documentTypes[k].metadatas[l];
                                var replicated = $scope.getReplicatedMetadata(m);
                                if (replicated) {
                                    m.metadataValue = replicated.metadataValue;
                                    m.metadataReadOnly = true;
                                    if (m.updatesName) {
                                        $scope.document.name = replicated.metadataValue;
                                    }
                                } else {
                                    m.metadataReadOnly = false;
                                }
                            }
                        }
                    };

                    /*
                     * Agrgea un contenedor al documento.
                     */
                    $scope.selectContainer = function (item) {

                        var found = false;

                        containerTypeService.getById(item.containerTypeId).then(function (type) {
                            type.metadata.forEach(function (m) {

                                if (m.isReplicated) {
                                    $scope.aux.metadataReplicate.push({
                                        value: undefined,
                                        metadataId: m.metadataId,
                                        containerId: undefined
                                    });
                                    found = true;
                                }
                            });

                            if (found) {
                                documentContainerService.getById(item.id).then(function (container) {
                                    $scope.aux.metadataReplicate.forEach(function loadValues(metadata) {
                                        for (var i = 0; container.metadatas.length > i; i++) {
                                            if (metadata.metadataId === container.metadatas[i].metadataId) {
                                                metadata.metadataValue = container.metadatas[i].metadataValue;
                                                metadata.containerId = item.id;
                                                break;
                                            }
                                        }

                                        $scope.replicateValues();
                                    });
                                }, function (error) {
                                    if (error && error.status === 403) {
                                        // si no tiene permisos lo dejo seguir. Los datos se van a replicar a nivel de api
                                        return;
                                    }

                                    errors.showError(error);
                                });
                            }
                        }, function (error) {
                            if (error && error.status === 403) {
                                // si no tiene permisos lo dejo seguir. Los datos se van a replicar a nivel de api
                                return;
                            }

                            errors.showError(error);
                        });
                    };

                    /*
                     * Remueve un contenedor del documento.
                     */
                    $scope.removeContainer = function (item) {
                        var aux = [];

                        $scope.aux.metadataReplicate.forEach(function (metadata) {
                            if (metadata.containerId !== item.id) {
                                aux.push(metadata);
                            }
                        });

                        $scope.aux.metadataReplicate = aux;
                        $scope.replicateValues();
                    };

                    /*
                     * Cierra la pantalla de indexación
                     */
                    function closeIndexer() {
                        $scope.indexer = {
                            closed: true,
                            loading: false,
                            content: null,
                            index: null,
                            invalid: false,
                            item: null
                        };
                    }

                    /*
                     * Finaliza la indexación y cierra el indexador
                     */
                    $scope.stopIndexing = function () {

                        return errors.showConfirm('DocumentIndexingConfirmClose').then(function (res) {
                            if (res) {

                                // cancelo la digitalización
                                if (cancelDeferred) {
                                    cancelDeferred.resolve();
                                }

                                twainCapture.clear();

                                var document = documentsList.tail();

                                if (document) {

                                    // si no es el último documento muestro un mensaje diferente 
                                    var saveText = $scope.currentDocumentNode.next ? 'DocumentIndexingConfirmClosePending' : null;

                                    saveWithConfirm(saveText)
                                        .then(function (res) {

                                            if (res.result !== false) {
                                                closeIndexer();

                                                createDocumentObject(true);
                                            }
                                        }, function (error) {
                                            errors.showError(error);
                                        });
                                } else {

                                    closeIndexer();

                                    createDocumentObject(true);
                                }
                            }
                        });
                    };

                    $scope.digitalizedFiles = 0;
                    $scope.processedFiles = 0;
                    $scope.loadingDocument = false;
                    $scope.fileNameTemplate = 'Captura $unique$';
                    $scope.barcodeConfig = null;
                    var checkedSame = false;
                    var scanLoadingModal = null;

                    function getOuOuConfigMetadataValues(ouOuConfig) {

                        var obj = {};

                        var values = {};

                        angular.forEach(ouOuConfig.metadataValues, function (ouOuConfigMetadataValue) {
                            values[ouOuConfigMetadataValue.organizationalUnitConfigMetadata.id] = ouOuConfigMetadataValue;
                        });

                        angular.forEach(ouOuConfig.organizationalUnitConfig.metadata, function (ouConfigMetadata, key) {
                            obj[ouConfigMetadata.metadata.name] = values[ouConfigMetadata.id].value;
                        });

                        return obj;
                    }

                    /*
                     * Obtengo la configuración del barcode para la OU
                     */
                    organizationalUnitService.getConfigByName(authExtend.getOrganizationId(), '#BarcodeConfigOuType')
                        .then(function (result) {
                            if (result.length) {

                                var values = getOuOuConfigMetadataValues(result[0]);

                                $scope.barcodeConfig = {
                                    defined: true,
                                    virtualSeparator: values["#BarcodeIncludeMode"] === '2',
                                    includeNoBarcode: values["#BarcodeIncludeMode"] === '1',
                                    length: values["#BarcodeLength"] || -1,
                                    prefix: values["#BarcodePrefix"] || undefined,
                                    type: values["#BarcodeType"] ? parseInt(values["#BarcodeType"]) : twainCapture.BarcodeTypes.All
                                };
                            } else {
                                $scope.barcodeConfig = {
                                    defined: false
                                }
                            }
                        }, function (error) {
                            errors.showError(error);
                            $scope.barcodeConfig = {
                                defined: false
                            }
                        });

                    /*
                     * Retornará una promesa que se resolverá con true si la imagen con el indice especificado pertenece al mismo documento.
                     */
                    function isSameDocument(index) {

                        // el documento actual es el tail() de la lista
                        var document = documentsList.tail().data;

                        var files = $scope.currentDocumentNode.next ? document.files : $scope.aux.files;

                        if ($scope.barcodeConfig.defined) {

                            var deferred = $q.defer();

                            // tengo que comparar con el barcode info del documento.
                            twainCapture.readBarcodes(index, $scope.barcodeConfig)
                                .then(function (barcodeData) {

                                    if ($scope.barcodeConfig.virtualSeparator) {
                                        if (barcodeData.length === 1
                                            && (barcodeData[0].type & $scope.barcodeConfig.type) !== 0
                                            && barcodeData[0].content === $scope.barcodeConfig.prefix) {
                                            // cuando se lee el virtual separator entonces se ignora la 
                                            // página y se cambia de documento.
                                            return deferred.resolve({ same: false, ignore: true });
                                        } else {
                                            return deferred.resolve({ same: true, barcodeFound: true });
                                        }
                                    }

                                    if (files.length === 0) {
                                        document.barcodeData = barcodeData;
                                        // no tiene archivos
                                        return deferred.resolve({
                                            same: true,
                                            barcodeFound: barcodeData.length !== 0,
                                            barcode: barcodeData.length ? barcodeData[0].content : null
                                        });
                                    }

                                    var ret = true;

                                    if (barcodeData.length === 0) {
                                        // No hay un barcode que cumpla con el prefijo, tipo y longitud de la configuración                                        
                                        ret = ($scope.barcodeConfig.includeNoBarcode);
                                    } else if (document.barcodeData.length !== barcodeData.length) {
                                        // El documento tiene barcodes que cumplen los filtros y no coinciden.
                                        ret = false;
                                    } else {

                                        // barcodeData tiene los barcodes que cumplen los filtros.
                                        for (var i = 0; i < barcodeData.length; i++) {

                                            if (document.barcodeData[i].content !== barcodeData[i].content
                                                || document.barcodeData[i].type !== barcodeData[i].type) {
                                                ret = false;
                                                break;
                                            }
                                        }
                                    }

                                    return deferred.resolve({
                                        same: ret,
                                        barcodeFound: barcodeData.length !== 0,
                                        barcode: barcodeData.length ? barcodeData[0].content : null
                                    });

                                }, function (errorCode) {
                                    errors.showError($translate.instant('DocumentBarcodeReadError', { errorCode: errorCode }));
                                    deferred.reject();
                                });

                            return deferred.promise;

                        } else {

                            if (files.length === 0) {
                                document.barcodeData = [];
                                // no tiene archivos
                                return $q.resolve({ same: true, barcodeFound: true });
                            }

                            // No se distinguen pues no hay configuración de barcodes para distinguir.
                            return $q.resolve({ same: false, barcodeFound: true });
                        }
                    }

                    var processingImages = false;

                    /**
                     * @description Se verificará si las imagenes escaneadas pertenecen al documento actual.
                     *              Si es así entonces se agregarán al documento actual. Si no, no se hace nada.
                     */
                    function processImages(continuation) {

                        // no es necesaria la verificación
                        if (checkedSame || (processingImages && !continuation)) {
                            return;
                        }

                        processingImages = true;

                        if (twainCapture.imagesCount()) {

                            if ($scope.document.dummy) {
                                createNewDocument();
                            }

                            if (!$scope.currentDocumentNode.next && $scope.aux.files.length === 0) {
                                $scope.indexer.loading = true;
                            }

                            var document = documentsList.last();

                            isSameDocument(0).then(function (ret) {

                                if (!ret.same) {

                                    var files = $scope.currentDocumentNode.next ? document.files : $scope.aux.files;

                                    if (files.length) {

                                        checkedSame = true;
                                        processingImages = false;

                                        // no es del mismo documento la imagen
                                        document.hasMoreImages = false;
                                    }

                                    if (ret.ignore) {
                                        // borro la imagen puesto que hay que ignorarla.
                                        var deletePromise = twainCapture.deleteFirstImage();

                                        if (files.length === 0) {
                                            deletePromise.then(function () {
                                                processImages(true);
                                            });
                                        }
                                    }
                                }
                                else {
                                    addFile(ret.barcode).then(function () {
                                        processImages(true);
                                    });
                                }
                            }, function () {
                                // ocurrió un error
                                $scope.indexer.loading = false;
                            });

                        } else {
                            if (!$scope.digitalizing) {
                                checkedSame = true;
                                var document = documentsList.last();
                                if (document) {
                                    document.hasMoreImages = false;
                                }
                            } else {
                                checkedSame = false;
                            }
                            processingImages = false;
                        }
                    }

                    /*
                     * Retornará true si ya no se está digitalizando y no hay mas imagenes en el buffer.
                     */
                    $scope.hasFinished = function () {
                        return !processingImages && !$scope.digitalizing && twainCapture.imagesCount() === 0;
                    }

                    /**
                     * @description Mostrará el cartel de fin de digitalización y removera el último documento si no posee archivos.
                     *              Cerrando además el indexador si es el único documento.
                     */
                    function indexingFinished(close) {

                        if (!$scope.currentDocumentNode
                            || close
                            || ($scope.currentDocumentNode.next == null && $scope.aux.files.length === 0)) {

                            if ($scope.currentDocumentNode.prev && !close) {
                                if (!$scope.currentDocumentNode.data.id) {
                                    $scope.prevDocument(true);
                                    documentsList.tail()
                                                 .remove();
                                }
                            } else {
                                closeIndexer();
                                createDocumentObject(true);
                            }
                        }

                        errors.showSuccess('DocumentIndexingFinished');
                    }

                    /*
                     * Agrega la primer imagen como archivo al documento que se está digitalizando (el tail de la lista de documentos) y la remueve.
                     */
                    function addFile(barcode) {

                        // agrego la imagen al final de la lista 
                        return twainCapture.popImageFile($scope.fileNameTemplate).then(function (file) {

                            var fileArray = $scope.currentDocumentNode.next ? document.files : $scope.aux.files,
                                document = documentsList.tail().data;

                            file.barcodeFound = (barcode && true) || false;
                            fileArray.push(file);

                            if (fileArray.length === 1) {

                                if (document.name === '' && !document.metadataAsName) {
                                    document.name = barcode || fileArray[0].name;
                                }

                                if ($scope.document.id === undefined) {
                                    $timeout(function () {
                                        $scope.previewFile(fileArray[0] || null, 0);
                                    });
                                }
                            }
                        });
                    }

                    /**
                     * @description Crea un documento nuevo utilizando los documentos digitalizados hasta el momento.
                     *              Si no hay mas documentos y no se está digitalizando retornará false.
                     */
                    function createNewDocument() {

                        checkedSame = false;

                        if (!$scope.document.dummy) {
                            createDocumentObject();
                        } else {
                            delete $scope.document.dummy;
                        }

                        // agrego el documento a la lista
                        $scope.currentDocumentNode = documentsList.append($scope.document);

                        // trimming de la lista si es demasiado grande
                        if (maxDocumentsListSize !== -1) {
                            while (documensList.size() > maxDocumentsListSize) {
                                documensList.head()
                                            .remove();
                            }
                        }

                        var count = twainCapture.imagesCount();

                        if (count) {
                            processImages();
                        } else if ($scope.digitalizing) {
                            // no hay imagenes, pero esta digitalizando? -> muestro el loading
                            scanLoadingModal = alerts.loading($translate.instant('DocumentDigitalizeAquiringTitle'),
                                                              $translate.instant('DocumentDigitalizeAquiringText'));
                            return true;
                        }

                        return count !== 0;
                    }

                    /*
                     * Valida que el documento se pueda guardar.
                     */
                    function validateDocumentSave() {
                        if (!$scope.documentForm.$valid) {
                            $scope.documentForm.$setSubmitted();
                            errors.showError('VerifyFormData');
                            return false;
                        }

                        if ($scope.aux.files.indexOf(null) !== -1) {
                            errors.showError('DocumentIndexingLoadingImages');
                            return false;
                        }

                        if ($scope.document.hasMoreImages) {
                            errors.showError('DocumentMightHaveMoreImagesAlert');
                            return false;
                        }
                        return true;
                    }

                    /*
                     * Preguntará si desea guardar los cambios del documento y retornará una promesa que se cumple cuando se guardó o respondió que no.
                     */
                    function saveWithConfirm(text) {

                        // pregunto si lo quiere guardar.
                        return errors.showConfirm(text || 'DocumentIndexingSaveConfText')
                            .then(function (res) {
                                if (res) {

                                    if (!validateDocumentSave()) {
                                        return $q.when({ saved: true, result: false });
                                    }

                                    if ($scope.document.id) {
                                        return documentService.modify($scope.document, [])
                                            .then(function () {
                                                return { saved: true, result: true };
                                            });
                                    }

                                    return documentService.create($scope.document, $scope.aux.files)
                                        .then(function (result) {

                                            documentsList.tail().data = $scope.document = result.data[0];
                                            $scope.document.isDocumentPerFile = false;
                                            $scope.document.metadataAsName = 0;

                                            return { saved: true, result: true };
                                        }, function (error) {
                                            return $q.reject(error);
                                        });
                                }
                                return $q.when({ saved: false, result: true });
                            });
                    }

                    /*
                     * Avanza al siguiente documento guardando el actual.
                     */
                    $scope.nextDocument = function (discard, finish) {

                        if (discard) {
                            // Como no tiene id se que es el último documento. 
                            // Remuevo el nodo de la lista y creo un nuevo documento.
                            var currNode = $scope.currentDocumentNode;
                            $scope.currentDocumentNode = $scope.currentDocumentNode.prev;
                            currNode.remove();

                            if (finish || !createNewDocument()) {
                                indexingFinished(finish);
                            }
                            return false;
                        }

                        if (!validateDocumentSave()) {
                            return false;
                        }

                        $scope.documentForm.$setPristine();

                        function done(result) {
                            if ($scope.currentDocumentNode.next == null) {

                                // reemplazo el documento por su ID para indicar que no es el que se está escaneando
                                $scope.currentDocumentNode.data = (result.data[0] || result.data).id;

                                if (!finish && twainCapture.imagesCount() === 0 && twainCapture.feederLoaded()) {
                                    // intento seguir digitalizando
                                    $scope.beginDigitalization(true);
                                } else if (finish || !createNewDocument()) {    // no invertir, porque no se tiene que ejecutar createNewDocument si finish = true
                                    indexingFinished(finish);
                                }

                                $scope.loadingDocument = false;

                            } else {
                                $scope.currentDocumentNode = $scope.currentDocumentNode.next;

                                loadDocument($scope.currentDocumentNode.data);
                            }
                        }

                        $scope.loadingDocument = true;

                        // guarda el documento actual
                        if ($scope.document.id) {
                            var files = $scope.document.files.filter(function (item) {
                                return angular.isUndefined(item.stream);
                            });

                            $scope.document.files = $scope.document.files.filter(function (item) {
                                return !angular.isUndefined(item.stream);
                            });
                            return documentService.modify($scope.document, files)
                                .then(done, function (error) {
                                    errors.showError(error);
                                    $scope.loadingDocument = false;
                                });
                        } else if (!discard) {
                            return documentService.create($scope.document, $scope.aux.files)
                                .then(done, function (error) {
                                    errors.showError(error);
                                    $scope.loadingDocument = false;
                                });
                        }
                    };

                    /*
                     * Avanza al documento anterior y pregunta si se desea guardar.
                     */
                    $scope.prevDocument = function (saved) {

                        $scope.loadingDocument = true;

                        if (!$scope.currentDocumentNode.next) {

                            if (!saved) {
                                return saveWithConfirm('DocumentIndexingSaveConfTextPreserved')
                                    .then(function (res) {
                                        if (res.saved) {
                                            if (res.result !== false) {
                                                $scope.prevDocument(true);
                                            } else {
                                                $scope.loadingDocument = false;
                                            }
                                        }
                                        else {
                                            $scope.currentDocumentNode.data.files = $scope.aux.files;
                                        }
                                    }, function (error) {
                                        errors.showError(error);
                                        $scope.loadingDocument = false;
                                    });
                            }
                        }

                        if ($scope.currentDocumentNode.prev) {
                            $scope.currentDocumentNode = $scope.currentDocumentNode.prev;

                            return loadDocument($scope.currentDocumentNode.data);
                        }

                        return false;
                    };

                    $scope.configureDigitalization = function () {
                        twainCapture.showConfigUi();
                    };

                    /**
                     * Comienza la digitalización e indexado.
                     */
                    $scope.beginDigitalization = function (continuation) {

                        if ($scope.digitalizing) {
                            errors.showError('AlreadyDigitalizing');
                            return;
                        }

                        if (!$scope.digitalizationForm.$valid) {
                            $scope.digitalizationForm.$setSubmitted();
                            errors.showError('VerifyFormData');
                            return false;
                        }

                        if (!twainCapture.feederLoaded()) {
                            errors.showError('FeederEmpty');
                            return false;
                        }

                        if ($scope.fileNameTemplate.indexOf('$unique$') === -1) {
                            $scope.fileNameTemplate += ' $unique$';
                        }

                        if (!continuation) {
                            $scope.digitalizedFiles = 0;
                            $scope.processedFiles = 0;
                            $scope.currentDocumentNode = null;
                            $scope.indexer.closed = false;
                            documentsList = doublyLinkedList();
                        } else {
                            // Si es continuation entonces creo un nuevo documento
                            // para que no se intente apendar imagenes al actual
                            // NOTA: Este documento no va a tener imagenes aún.
                            createNewDocument();
                        }

                        checkedSame = false;
                        $scope.digitalizing = true;

                        cancelDeferred = $q.defer();

                        if (!twainCapture.feederLoaded()) {
                            return $q.when(false);
                        }

                        scanLoadingModal = alerts.loading($translate.instant('DocumentDigitalizeAquiringTitle'),
                                                          $translate.instant('DocumentDigitalizeAquiringText'));

                        return twainCapture.scanBatched(5, cancelDeferred, { showIndicator: false, showUi: false })
                                    .then(function () {
                                        $scope.digitalizing = false;

                                        // si se está mostrando el scanLoadingModal es porque nunca se invocó al notify
                                        // por ende si además el documento no posee archivos, puedo indicar que finalizó la indexación
                                        if (twainCapture.imagesCount() === 0) {

                                            var doc = documentsList.last();

                                            if (doc) {
                                                doc.hasMoreImages = false;
                                            }

                                            if (scanLoadingModal) {
                                                indexingFinished();
                                            }
                                        }

                                        if (scanLoadingModal) {
                                            scanLoadingModal.close();
                                            scanLoadingModal = null;
                                        }

                                    }, function (error) {
                                        errors.showError(error);

                                        $scope.digitalizing = false;
                                        $scope.document.hasMoreImages = false;
                                    }, function (count) {
                                        if (scanLoadingModal) {
                                            scanLoadingModal.close();
                                            scanLoadingModal = null;
                                        }
                                        // cada notificación corresponde a un batch de archivos porque el batch es 1
                                        $scope.digitalizedFiles += count;

                                        // Creo los documentos
                                        processImages();
                                    });
                    };

                    $scope.$watch(function () {
                        return twainCapture.isAvailable();
                    }, function (val) {
                        $scope.digitalizerNotAvaliable = !val;
                    });
                }
        ]);
})();